











import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Tabs extends Vue {
    @Prop({ required: true, type: Array }) options!: Array<{ [key: string]: string }>
    @Prop({ required: true, type: String }) selectedKey!: string
    @Prop({ required: true, type: Function }) onClick!: Function

    selected (key: string): boolean {
      return this.selectedKey === key
    }
}

